export default {
  'sustainability.menu': 'Sustainability',
  'sustainability.noAccess': 'No access to sustainability',

  'sustainability.menu.audit': 'Audit',
  'sustainability.menu.audit.sdg': 'SDG Audit',
  'sustainability.menu.audit.dataReadiness': 'Data Readiness',

  'sustainability.menu.modules': 'Modules',
  'sustainability.menu.modules.csrd': 'CSRD (Corporate Sustainability Reporting Directive)',
  'sustainability.menu.modules.esg': 'ESG (Environment Social Governance)',
  'sustainability.menu.modules.ghg': 'GHG (Greenhouse Gas Protocol)',
  'sustainability.menu.modules.gri': 'GRI (Global Reporting Initiative)',
  'sustainability.menu.modules.sbti': 'SBTi (Science Based Targets initiative)',
  'sustainability.menu.modules.sdg': 'SDG (Sustainable Development Goals)',

  'sustainability.module.gri.title': 'GRI',
  'sustainability.module.gri.report.title': 'Generate report',
  'sustainability.module.gri.report.range': 'Range',
  'sustainability.module.gri.report.resolution': 'Resolution',
  'sustainability.module.gri.report.trends': 'Trends',
  'sustainability.module.gri.report.benchmark': 'Benchmark',
  'sustainability.module.gri.report.startValue': 'Start value',
  'sustainability.module.gri.report.transparencyDetail': 'Transparancy detail',
  'sustainability.module.gri.report.conversionFactors': 'Conversion factors',
  'sustainability.module.gri.report.button.pdf': 'Generate PDF',
  'sustainability.module.gri.report.button.csv': 'Generate CSV',

  'sustainability.module.gri.bulk.enable.success': 'Selected items are enabled',
  'sustainability.module.gri.bulk.enable.error': 'An error occured while enabling the disclosures',

  'sustainability.module.gri.bulk.disable.success': 'Selected items are disabled',
  'sustainability.module.gri.bulk.disable.error':
    'An error occured while disabling the disclosures',

  'sustainability.module.gri.disclsoureDisableModel.title': 'Disable disclosure(s)',
  'sustainability.module.gri.disclsoureDisableModel.button.submit': 'Disable disclosure(s)',

  'sustainability.module.ghg.title': 'GHG (Greenhouse Gas Protocol)',

  'sustainability.ghg.scope3.all': 'All',
  'sustainability.ghg.scope3.upstreamPurchasedEnergyFuels': 'Upstream - Purchased Energy Fuels',
  'sustainability.ghg.scope3.upstreamPurchasedVehicleFuels': 'Upstream - Purchased Vehicle Fuels',
  'sustainability.ghg.scope3.upstreamPurchasedEnergy': 'Upstream - Purchased Energy',
  'sustainability.ghg.scope3.tndLosses': 'T&D losses',
}
